export const vegMenuStandard499 = [
    // ===== STARTERS =====
    {
        id: 101,
        title: 'Paneer Tikka',
        category: 'starters',
        description: 'Classic tandoori paneer cubes with smoky char.',
        rating: 4.8,
        image: '/Images/VEG-STARTERS-MENU/1Paneer tikka.jpg',
        serves: 20,
        quantity: '40pc',
        unit: 'pcs'
    },
    {
        id: 102,
        title: 'Malai Paneer Tikka',
        category: 'starters',
        description: 'Creamy malai-marinated paneer, grilled.',
        rating: 4.8,
        image: '/Images/JainMenuStarters/9MALAI PANEER TIKKA.jpg',
        serves: 20,
        quantity: '40pc',
        unit: 'pcs'
    },
    {
        id: 103,
        title: 'Haryali Paneer Tikka',
        category: 'starters',
        description: 'Green herb marinade, fresh and smoky.',
        rating: 4.8,
        image: '/Images/VEG-STARTERS-MENU/2Haryali paneer tikka.jpg',
        serves: 20,
        quantity: '40pc',
        unit: 'pcs'
    },
    {
        id: 104,
        title: 'Soya Chaap Tikka',
        category: 'starters',
        description: 'Tandoor-roasted soya chaap with spices.',
        rating: 4.6,
        image: '/Images/VEG-STARTERS-MENU/9Soya chaap tikka.jpg',
        serves: 20,
        quantity: '40pc',
        unit: 'pcs'
    },
    {
        id: 105,
        title: 'Malai Soya Tikka',
        category: 'starters',
        description: 'Creamy soya chaap skewers.',
        rating: 4.6,
        image: '/Images/VEG-STARTERS-MENU/10Malai Soya Tikka.jpg',
        serves: 20,
        quantity: '40pc',
        unit: 'pcs'
    },
    {
        id: 106,
        title: 'Tandoori Aloo',
        category: 'starters',
        description: 'Spiced baby potatoes, tandoor-roasted.',
        rating: 4.5,
        image: '/Images/VEG-STARTERS-MENU/7Tandoori aloo.jpg',
        serves: 20,
        quantity: '40pc',
        unit: 'pcs'
    },
    {
        id: 107,
        title: 'Dry Manchurian',
        category: 'starters',
        description: 'Crispy veggie balls tossed in Indo-Chinese sauce.',
        rating: 4.5,
        image: '/Images/VEG-STARTERS-MENU/11Dry Manchurian.jpg',
        serves: 20,
        quantity: '40pc',
        unit: 'pcs'
    },
    {
        id: 108,
        title: 'Honey Chilli Potatoes',
        category: 'starters',
        description: 'Crispy fries glazed with honey-chilli.',
        rating: 4.5,
        image: '/Images/VEG-STARTERS-MENU/24Honey chilli potato.jpg',
        portionSize: '2kg',
        pricePerPortion: '₹499',
        basePrice: 499,
        serves: 20,
        quantity: '2kg',
        unit: 'kg'
    },
    {
        id: 109,
        title: 'Chilli Paneer',
        category: 'starters',
        description: 'Indo-Chinese chilli paneer, dry.',
        rating: 4.7,
        image: '/Images/VEG-STARTERS-MENU/13Chili Paneer.jpg',
        serves: 20,
        quantity: '40pc',
        unit: 'pcs'
    },
    {
        id: 110,
        title: 'Hara Bhara Kabab',
        category: 'starters',
        description: 'Spinach-pea cutlets, pan-seared.',
        rating: 4.6,
        image: '/Images/VEG-STARTERS-MENU/16Hara Bhara Kabab.jpg',
        serves: 20,
        quantity: '40pc',
        unit: 'pcs'
    },
    {
        id: 111,
        title: 'Shami Kabab (Veg)',
        category: 'starters',
        description: 'Rich veg shami patties.',
        rating: 4.5,
        image: '/Images/VEG-STARTERS-MENU/15Veg shami kabab.jpg',
        serves: 20,
        quantity: '40pc',
        unit: 'pcs'
    },
    {
        id: 112,
        title: 'Spring Rolls',
        category: 'starters',
        description: 'Crispy veg spring rolls.',
        rating: 4.4,
        image: '/Images/VEG-STARTERS-MENU/19Spring Rolls.jpg',
        serves: 20,
        quantity: '40pc',
        unit: 'pcs'
    },
    {
        id: 113,
        title: 'Veg Dimsums',
        category: 'starters',
        description: 'Steamed veg dumplings.',
        rating: 4.4,
        image: '/Images/VEG-STARTERS-MENU/17Dahi ke shole.jpg',
        serves: 20,
        quantity: '40pc',
        unit: 'pcs'
    },
    {
        id: 114,
        title: 'Paneer Dimsums',
        category: 'starters',
        description: 'Steamed dumplings stuffed with paneer.',
        rating: 4.4,
        image: '/Images/VEG-STARTERS-MENU/3Paneer malai tikka.jpg',
        serves: 20,
        quantity: '40pc',
        unit: 'pcs'
    },
    {
        id: 115,
        title: 'Cajun Potatoes',
        category: 'starters',
        description: 'Crispy potatoes with cajun mayo.',
        rating: 4.5,
        image: '/Images/VEG-STARTERS-MENU/23Cajun potato.jpg',
        serves: 20,
        quantity: '40pc',
        unit: 'pcs'
    },

    // ===== MAIN =====
    {
        id: 201,
        title: 'Paneer Lababdar',
        category: 'main',
        description: 'Rich tomato-cashew gravy with paneer.',
        rating: 4.8,
        image: '/Images/MianVegMenu/1Paneer Lababdar.jpg',
        portionSize: '2kg',
        pricePerPortion: '₹499',
        basePrice: 499,
        serves: 20,
        quantity: '2kg',
        unit: 'kg'
    },
    {
        id: 202,
        title: 'Paneer Kadhai',
        category: 'main',
        description: 'Spicy onion-capsicum masala.',
        rating: 4.7,
        image: '/Images/MianVegMenu/2Kadhai paneer.jpg',
        portionSize: '2kg',
        pricePerPortion: '₹499',
        basePrice: 499,
        serves: 20,
        quantity: '2kg',
        unit: 'kg'
    },
    {
        id: 203,
        title: 'Paneer Shahi',
        category: 'main',
        description: 'Mild, creamy shahi gravy.',
        rating: 4.7,
        image: '/Images/MianVegMenu/5Paneer Shahi.jpg',
        portionSize: '2kg',
        pricePerPortion: '₹499',
        basePrice: 499,
        serves: 20,
        quantity: '2kg',
        unit: 'kg'
    },
    {
        id: 204,
        title: 'Paneer Matar',
        category: 'main',
        description: 'Green peas with paneer in tomato masala.',
        rating: 4.6,
        image: '/Images/MianVegMenu/6Paneer Matar.jpg',
        portionSize: '2kg',
        pricePerPortion: '₹499',
        basePrice: 499,
        serves: 20,
        quantity: '2kg',
        unit: 'kg'
    },
    {
        id: 205,
        title: 'Paneer Palak',
        category: 'main',
        description: 'Spinach puree with paneer cubes.',
        rating: 4.7,
        image: '/Images/MianVegMenu/7Paneer Palak.jpg',
        portionSize: '2kg',
        pricePerPortion: '₹499',
        basePrice: 499,
        serves: 20,
        quantity: '2kg',
        unit: 'kg'
    },
    {
        id: 206,
        title: 'Tawa Veg',
        category: 'main',
        description: 'Assorted veggies tossed on tawa.',
        rating: 4.5,
        image: '/Images/JainMenuMainCourse/8TAWA VEG.jpg',
        portionSize: '1.5kg',
        pricePerPortion: '₹499',
        basePrice: 499,
        serves: 20,
        quantity: '1.5kg',
        unit: 'kg'
    },
    {
        id: 207,
        title: 'Mix Veg',
        category: 'main',
        description: 'Seasonal mixed vegetables curry.',
        rating: 4.5,
        image: '/Images/MianVegMenu/14Mix veg.jpg',
        portionSize: '1.5kg',
        pricePerPortion: '₹499',
        basePrice: 499,
        serves: 20,
        quantity: '1.5kg',
        unit: 'kg'
    },
    {
        id: 208,
        title: 'Kadhai Vegetables',
        category: 'main',
        description: 'Chunky veg in kadhai masala.',
        rating: 4.5,
        image: '/Images/MianVegMenu/13Kadhai veg.jpg',
        portionSize: '1.5kg',
        pricePerPortion: '₹499',
        basePrice: 499,
        serves: 20,
        quantity: '1.5kg',
        unit: 'kg'
    },
    {
        id: 209,
        title: 'Aloo Gobhi Adraki',
        category: 'main',
        description: 'Cauliflower & potato with ginger.',
        rating: 4.6,
        image: '/Images/MianVegMenu/17Aloo Gobhi Adraki.jpg',
        portionSize: '1.5kg',
        pricePerPortion: '₹499',
        basePrice: 499,
        serves: 20,
        quantity: '1.5kg',
        unit: 'kg'
    },
    {
        id: 210,
        title: 'Soya Chaap Masala',
        category: 'main',
        description: 'Semi-gravy soya chaap curry.',
        rating: 4.6,
        image: '/Images/MianVegMenu/18Soya Chaap Masala.jpg',
        portionSize: '2kg',
        pricePerPortion: '₹499',
        basePrice: 499,
        serves: 20,
        quantity: '2kg',
        unit: 'kg'
    },
    {
        id: 211,
        title: 'Dal Makhani',
        category: 'main',
        description: 'Slow-cooked black lentils and rajma.',
        rating: 4.9,
        image: '/Images/MianVegMenu/19Dal Makhani.jpg',
        portionSize: '2kg',
        pricePerPortion: '₹499',
        basePrice: 499,
        serves: 20,
        quantity: '2kg',
        unit: 'kg'
    },
    {
        id: 212,
        title: 'Dal Tadka',
        category: 'main',
        description: 'Yellow dal tempered with ghee tadka.',
        rating: 4.6,
        image: '/Images/MianVegMenu/20Dal tadka.jpg',
        portionSize: '2kg',
        pricePerPortion: '₹499',
        basePrice: 499,
        serves: 20,
        quantity: '2kg',
        unit: 'kg'
    },
    {
        id: 213,
        title: 'Amritsari Chole',
        category: 'main',
        description: 'Spiced chickpeas Punjabi style.',
        rating: 4.7,
        image: '/Images/MianVegMenu/21Amritsari Chole.jpg',
        portionSize: '2kg',
        pricePerPortion: '₹499',
        basePrice: 499,
        serves: 20,
        quantity: '2kg',
        unit: 'kg'
    },
    {
        id: 214,
        title: 'Hakka Noodles',
        category: 'main',
        description: 'Veg hakka noodles, wok-tossed.',
        rating: 4.5,
        image: '/Images/MianVegMenu/22Hakka Noodles.jpg',
        portionSize: '1.5kg',
        pricePerPortion: '₹499',
        basePrice: 499,
        serves: 20,
        quantity: '1.5kg',
        unit: 'kg'
    },
    {
        id: 215,
        title: 'Veg Manchurian (Gravy/Dry)',
        category: 'main',
        description: 'Veg balls in Manchurian sauce.',
        rating: 4.5,
        image: '/Images/MianVegMenu/23VegManchurian.jpg',
        portionSize: '1.5kg',
        pricePerPortion: '₹499',
        basePrice: 499,
        serves: 20,
        quantity: '1.5kg',
        unit: 'kg'
    },
    {
        id: 216,
        title: 'Pasta (Red/White/Pink)',
        category: 'main',
        description: 'Choice of sauces, cheesy and hearty.',
        rating: 4.4,
        image: '/Images/MianVegMenu/27PastaRedWhitePink.jpg',
        portionSize: '2kg',
        pricePerPortion: '₹499',
        basePrice: 499,
        serves: 20,
        quantity: '2kg',
        unit: 'kg'
    },
    {
        id: 217, title: 'Pao Bhaaji',
        category: 'main',
        description: 'Mumbai-style bhaaji with buns.',
        rating: 4.7,
        image: '/Images/MianVegMenu/28Pao Bhaaji.jpg',
        portionSize: '2kg + 30pc pav',
        pricePerPortion: '₹499',
        basePrice: 499,
        serves: 20,
        quantity: '2kg+30pc',
        unit: 'mixed'
    },
    {
        id: 218, title: 'Peas Pulao ',
        category: 'main',
        description: 'Basmati rice cooked with green peas and mild spices.',
        rating: 4.7,
        image: '/Images/MianVegMenu/33Peas pulao.jpg',
        portionSize: '2kg',
        pricePerPortion: '₹499',
        basePrice: 499,
        serves: 20,
        quantity: '2kg',
        unit: 'kg'
    },

    // ===== RICE =====
    {
        id: 301,
        title: 'Steamed Rice',
        category: 'rice',
        description: 'Plain steamed rice.',
        rating: 4.5,
        image: '/Images/MianVegMenu/29Steamed Rice.jpg',
        portionSize: '2kg',
        pricePerPortion: '₹499',
        basePrice: 499,
        serves: 20,
        quantity: '2kg',
        unit: 'kg'
    },
    {
        id: 302,
        title: 'Jeera Rice',
        category: 'rice',
        description: 'Cumin tempered rice.',
        rating: 4.6,
        image: '/Images/MianVegMenu/30Jeera Rice.jpg',
        portionSize: '2kg',
        pricePerPortion: '₹499',
        basePrice: 499,
        serves: 20,
        quantity: '2kg',
        unit: 'kg'
    },
    {
        id: 303,
        title: 'Veg Fried Rice',
        category: 'rice',
        description: 'Indo-Chinese style fried rice.',
        rating: 4.5,
        image: '/Images/MianVegMenu/31Veg Fried Rice.jpg',
        portionSize: '2kg',
        pricePerPortion: '₹499',
        basePrice: 499,
        serves: 20,
        quantity: '2kg',
        unit: 'kg'
    },
    {
        id: 304,
        title: 'Peas Pulao',
        category: 'rice',
        description: 'Aromatic rice with green peas.',
        rating: 4.5,
        image: '/Images/JainNewImage/Peas Pulao.jpg',
        portionSize: '2kg',
        pricePerPortion: '₹499',
        basePrice: 499,
        serves: 20,
        quantity: '2kg',
        unit: 'kg'
    },

    // ===== BREADS =====
    {
        id: 401,
        title: 'Tandoori Roti',
        category: 'breads',
        description: 'Tandoor baked rotis.',
        rating: 4.6,
        image: '/Images/Breads/1Tandoori Roti.jpg',
        portionSize: '20pc',
        pricePerPortion: '₹499',
        basePrice: 499,
        serves: 20,
        quantity: '20pc',
        unit: 'pcs'
    },
    {
        id: 402,
        title: 'Naan / Butter Naan',
        category: 'breads',
        description: 'Soft naans with or without butter.',
        rating: 4.7,
        image: '/Images/Breads/2Naan-Butter Naan.jpg',
        portionSize: '20pc',
        pricePerPortion: '₹499',
        basePrice: 499,
        serves: 20,
        quantity: '20pc',
        unit: 'pcs'
    },
    {
        id: 403,
        title: 'Lachcha Paratha',
        category: 'breads',
        description: 'Layered whole-wheat parathas.',
        rating: 4.6,
        image: '/Images/Breads/3Lachcha Paratha.jpg',
        portionSize: '20pc',
        pricePerPortion: '₹499',
        basePrice: 499,
        serves: 20,
        quantity: '20pc',
        unit: 'pcs'
    },
    {
        id: 404,
        title: 'Garlic Naan',
        category: 'breads',
        description: 'Garlic-infused naan.',
        rating: 4.7,
        image: '/Images/Breads/4Garlic Naan.jpg',
        portionSize: '20pc',
        pricePerPortion: '₹499',
        basePrice: 499,
        serves: 20,
        quantity: '20pc',
        unit: 'pcs'
    },
    {
        id: 405,
        title: 'Misi Roti',
        category: 'breads',
        description: 'Spiced gram-flour roti.',
        rating: 4.4,
        image: '/Images/Breads/5Misi Roti.jpg',
        portionSize: '20pc',
        pricePerPortion: '₹499',
        basePrice: 499,
        serves: 20,
        quantity: '20pc',
        unit: 'pcs'
    },

    // ===== DESSERT =====
    {
        id: 501,
        title: 'Gulab Jamun',
        category: 'dessert',
        description: 'Khoya dumplings in syrup.',
        rating: 4.8,
        image: '/Images/Desserts/1Gulab Jamun.jpg',
        serves: 20,
        quantity: '40pc',
        unit: 'pcs'
    },
    {
        id: 502,
        title: 'Brownies',
        category: 'dessert',
        description: 'Chocolate fudge brownies.',
        rating: 4.6,
        image: '/Images/Desserts/2Brownies.jpg',
        portionSize: '30pc',
        pricePerPortion: '₹499',
        basePrice: 499,
        serves: 20,
        quantity: '30pc',
        unit: 'pcs'
    },
    {
        id: 503,
        title: 'Mango Phirni',
        category: 'dessert',
        description: 'Creamy rice phirni with mango.',
        rating: 4.6,
        image: '/Images/Desserts/3Mango Phirni.jpg',
        portionSize: '2kg',
        pricePerPortion: '₹499',
        basePrice: 499,
        serves: 20,
        quantity: '2kg',
        unit: 'kg'
    },
    {
        id: 504,
        title: 'Rasgulla',
        category: 'dessert',
        description: 'Spongy chhena balls in syrup.',
        rating: 4.7,
        image: '/Images/Desserts/4Rasgulla.jpg',
        serves: 20,
        quantity: '40pc',
        unit: 'pcs'
    },
    {
        id: 505,
        title: 'Kheer',
        category: 'dessert',
        description: 'Traditional rice pudding.',
        rating: 4.7,
        image: '/Images/Desserts/5Kheer.jpg',
        portionSize: '2kg',
        pricePerPortion: '₹499',
        basePrice: 499,
        serves: 20,
        quantity: '2kg',
        unit: 'kg'
    },
    {
        id: 506,
        title: 'Moongdal Halwa',
        category: 'dessert',
        description: 'Ghee-rich moong dal halwa.',
        rating: 4.8,
        image: '/Images/Desserts/6Moongdal halwa.jpg',
        portionSize: '2kg',
        pricePerPortion: '₹499',
        basePrice: 499,
        serves: 20,
        quantity: '2kg',
        unit: 'kg'
    }
];

export const vegMenuPremium599 = [
    // ===== STARTERS =====
    {
        id: 601,
        title: 'Paneer Tikka',
        category: 'starters',
        description: 'Classic tandoori paneer.',
        rating: 4.8,
        image: '/Images/VEG-STARTERS-MENU/1Paneer tikka.jpg',
        serves: 20,
        quantity: '40pc',
        unit: 'pcs'
    },
    {
        id: 602,
        title: 'Paneer Malai Tikka',
        category: 'starters',
        description: 'Silky malai marinade.',
        rating: 4.8,
        image: '/Images/VEG-STARTERS-MENU/3Paneer malai tikka.jpg',
        serves: 20,
        quantity: '40pc',
        unit: 'pcs'
    },
    {
        id: 603,
        title: 'Kesariya Paneer Tikka',
        category: 'starters',
        description: 'Saffron-kissed paneer tikka.',
        rating: 4.7,
        image: '/Images/VEG-STARTERS-MENU/4Kesariya paneer tikka.jpg',
        serves: 20,
        quantity: '40pc',
        unit: 'pcs'
    },
    {
        id: 604,
        title: 'Chilli Paneer Tikka',
        category: 'starters',
        description: 'Spicy marinade, grilled.',
        rating: 4.6,
        image: '/Images/VEG-STARTERS-MENU/5Chilli paneer Tikka.jpg',
        serves: 20,
        quantity: '40pc',
        unit: 'pcs'
    },
    {
        id: 605,
        title: 'Malai Broccoli Tikka',
        category: 'starters',
        description: 'Creamy broccoli florets, tandoor-roasted.',
        rating: 4.6,
        image: '/Images/VEG-STARTERS-MENU/6Malai broccoli tikka.jpg',
        serves: 20,
        quantity: '40pc',
        unit: 'pcs'
    },
    {
        id: 606,
        title: 'Stuffed Aloo Tikka',
        category: 'starters',
        description: 'Spiced stuffed potatoes, grilled.',
        rating: 4.5,
        image: '/Images/VEG-STARTERS-MENU/8Stuffed aloo tikka.jpg',
        serves: 20,
        quantity: '40pc',
        unit: 'pcs'
    },
    {
        id: 607,
        title: 'Malai Soya Tikka',
        category: 'starters',
        description: 'Creamy soya chaap skewers.',
        rating: 4.6,
        image: '/Images/VEG-STARTERS-MENU/10Malai Soya Tikka.jpg',
        serves: 20,
        quantity: '40pc',
        unit: 'pcs'
    },
    {
        id: 608,
        title: 'Dry Manchurian',
        category: 'starters',
        description: 'Crispy Indo-Chinese bites.',
        rating: 4.5,
        image: '/Images/VEG-STARTERS-MENU/11Dry Manchurian.jpg',
        serves: 20,
        quantity: '40pc',
        unit: 'pcs'
    },
    {
        id: 609,
        title: 'Chilli Basil Tofu',
        category: 'starters',
        description: 'Wok-tossed tofu with chilli & basil.',
        rating: 4.5,
        image: '/Images/VEG-STARTERS-MENU/12Chilli basil tofu.jpg',
        serves: 20,
        quantity: '40pc',
        unit: 'pcs'
    },
    {
        id: 610,
        title: 'Chilli Paneer',
        category: 'starters',
        description: 'Indo-Chinese chilli paneer.',
        rating: 4.7,
        image: '/Images/VEG-STARTERS-MENU/13Chili Paneer.jpg',
        serves: 20,
        quantity: '40pc',
        unit: 'pcs'
    },
    {
        id: 611,
        title: 'Chilli Mushroom',
        category: 'starters',
        description: 'Spicy mushrooms, dry.',
        rating: 4.5,
        image: '/Images/JainMenuStarters/5.Chilli Mushroom.png',
        portionSize: '50pc',
        pricePerPortion: '₹499',
        basePrice: 499,
        serves: 20,
        quantity: '50pc',
        unit: 'pcs'
    },
    {
        id: 612,
        title: 'Hara Bhara Kabab',
        category: 'starters',
        description: 'Spinach-pea kababs.',
        rating: 4.6,
        image: '/Images/VEG-STARTERS-MENU/16Hara Bhara Kabab.jpg',
        portionSize: '40pc',
        pricePerPortion: '₹499',
        basePrice: 499,
        serves: 20,
        quantity: '40pc',
        unit: 'pcs'
    },
    {
        id: 613,
        title: 'Dahi ke Kabab',
        category: 'starters',
        description: 'Melt-in-mouth yogurt kababs.',
        rating: 4.7,
        image: '/Images/JainMenu-STARTERS/6.Dahi Kebab.jpg',
        portionSize: '40pc',
        pricePerPortion: '₹499',
        basePrice: 499,
        serves: 20,
        quantity: '40pc',
        unit: 'pcs'
    },
    {
        id: 614,
        title: 'Spring Rolls',
        category: 'starters',
        description: 'Crispy veg rolls.',
        rating: 4.4,
        image: '/Images/VEG-STARTERS-MENU/19Spring Rolls.jpg',
        portionSize: '40pc',
        pricePerPortion: '₹499',
        basePrice: 499,
        serves: 20,
        quantity: '40pc',
        unit: 'pcs'
    },
    {
        id: 615,
        title: 'Spicy Veg (Crystal Dimsum)',
        category: 'starters',
        description: 'Crystal wrapper spicy veg dimsum.',
        rating: 4.4,
        image: '/Images/VEG-STARTERS-MENU/20Spicy veg (crystal dimsum).jpg',
        portionSize: '40pc',
        pricePerPortion: '₹499',
        basePrice: 499,
        serves: 20,
        quantity: '40pc',
        unit: 'pcs'
    },
    {
        id: 616,
        title: 'Cocktail Samosa',
        category: 'starters',
        description: 'Mini samosas, party-friendly.',
        rating: 4.5,
        image: '/Images/VEG-STARTERS-MENU/25Cocktail samosa.jpg',
        portionSize: '40pc',
        pricePerPortion: '₹499',
        basePrice: 499,
        serves: 20,
        quantity: '40pc',
        unit: 'pcs'
    },
    {
        id: 617,
        title: 'Cottage Cheese Satay',
        category: 'starters',
        description: 'Skewered cottage cheese with satay glaze.',
        rating: 4.6,
        image: '/Images/VEG-STARTERS-MENU/26Cottage cheese satay.jpg',
        portionSize: '40pc',
        pricePerPortion: '₹499',
        basePrice: 499,
        serves: 20,
        quantity: '40pc',
        unit: 'pcs'
    },

    // ===== MAIN =====
    {
        id: 701,
        title: 'Paneer Lababdar',
        category: 'main',
        description: 'Rich tomato-cashew gravy with paneer.',
        rating: 4.8,
        image: '/Images/MianVegMenu/1Paneer Lababdar.jpg',
        portionSize: '2kg',
        pricePerPortion: '₹499',
        basePrice: 499,
        serves: 20,
        quantity: '2kg',
        unit: 'kg'
    },
    {
        id: 702,
        title: 'Paneer Butter Masala',
        category: 'main',
        description: 'Buttery, creamy tomato gravy.',
        rating: 4.9,
        image: '/Images/MianVegMenu/3Paneer butter masala.jpg',
        portionSize: '2kg',
        pricePerPortion: '₹499',
        basePrice: 499,
        serves: 20,
        quantity: '2kg',
        unit: 'kg'
    },
    {
        id: 703,
        title: 'Paneer Tikka Masala',
        category: 'main',
        description: 'Smoky tikka in masala gravy.',
        rating: 4.8,
        image: '/Images/MianVegMenu/4Paneer tikka masala.jpg',
        portionSize: '2kg',
        pricePerPortion: '₹499',
        basePrice: 499,
        serves: 20,
        quantity: '2kg',
        unit: 'kg'
    },
    {
        id: 704,
        title: 'Paneer Shahi',
        category: 'main',
        description: 'Royal creamy gravy.',
        rating: 4.7,
        image: '/Images/MianVegMenu/5Paneer Shahi.jpg',
        portionSize: '2kg',
        pricePerPortion: '₹499',
        basePrice: 499,
        serves: 20,
        quantity: '2kg',
        unit: 'kg'
    },
    {
        id: 705,
        title: 'Paneer Matar',
        category: 'main',
        description: 'Paneer with peas in tomato masala.',
        rating: 4.6,
        image: '/Images/MianVegMenu/6Paneer Matar.jpg',
        portionSize: '2kg',
        pricePerPortion: '₹499',
        basePrice: 499,
        serves: 20,
        quantity: '2kg',
        unit: 'kg'
    },
    {
        id: 706,
        title: 'Paneer Palak',
        category: 'main',
        description: 'Spinach base with paneer.',
        rating: 4.7,
        image: '/Images/MianVegMenu/7Paneer Palak.jpg',
        portionSize: '2kg',
        pricePerPortion: '₹499',
        basePrice: 499,
        serves: 20,
        quantity: '2kg',
        unit: 'kg'
    },
    {
        id: 707,
        title: 'Malai Kofta',
        category: 'main',
        description: 'Paneer-potato koftas in rich gravy.',
        rating: 4.7,
        image: '/Images/MianVegMenu/8Malai kofta.jpg',
        portionSize: '2kg',
        pricePerPortion: '₹499',
        basePrice: 499,
        serves: 20,
        quantity: '2kg',
        unit: 'kg'
    },
    {
        id: 708,
        title: 'Nargisi Kofta',
        category: 'main',
        description: 'Stuffed veg koftas in aromatic curry.',
        rating: 4.6,
        image: '/Images/MianVegMenu/9Nargisi kofta.jpg',
        portionSize: '2kg',
        pricePerPortion: '₹499',
        basePrice: 499,
        serves: 20,
        quantity: '2kg',
        unit: 'kg'
    },
    {
        id: 709,
        title: 'Korma Style Kofta',
        category: 'main',
        description: 'Korma gravy with veg kofta.',
        rating: 4.6,
        image: '/Images/MianVegMenu/10Korma style kofta.jpg',
        portionSize: '2kg',
        pricePerPortion: '₹499',
        basePrice: 499,
        serves: 20,
        quantity: '2kg',
        unit: 'kg'
    },
    {
        id: 710,
        title: 'Dum Aloo Kashmiri',
        category: 'main',
        description: 'Sweet-spicy Kashmiri style dum aloo.',
        rating: 4.6,
        image: '/Images/MianVegMenu/11Dum aloo kashmiri.jpg',
        portionSize: '2kg',
        pricePerPortion: '₹499',
        basePrice: 499,
        serves: 20,
        quantity: '2kg',
        unit: 'kg'
    },
    {
        id: 711,
        title: 'Mix Veg',
        category: 'main',
        description: 'Seasonal mixed vegetables curry.',
        rating: 4.5,
        image: '/Images/JainNewImage/MIX VEG.jpg',
        portionSize: '1.5kg',
        pricePerPortion: '₹499',
        basePrice: 499,
        serves: 20,
        quantity: '1.5kg',
        unit: 'kg'
    },
    {
        id: 712,
        title: 'Matar Mushroom',
        category: 'main',
        description: 'Green peas with mushrooms.',
        rating: 4.5,
        image: '/Images/MianVegMenu/15Matar mushroom.jpg',
        portionSize: '1.5kg',
        pricePerPortion: '₹499',
        basePrice: 499,
        serves: 20,
        quantity: '1.5kg',
        unit: 'kg'
    },
    {
        id: 713,
        title: 'Methi Matar Malai',
        category: 'main',
        description: 'Fenugreek, peas & cream.',
        rating: 4.7,
        image: '/Images/MianVegMenu/16Methi matar malai.jpg',
        portionSize: '2kg',
        pricePerPortion: '₹499',
        basePrice: 499,
        serves: 20,
        quantity: '2kg',
        unit: 'kg'
    },
    {
        id: 714,
        title: 'Aloo Gobhi Adraki',
        category: 'main',
        description: 'Cauliflower & potato with ginger.',
        rating: 4.6,
        image: '/Images/MianVegMenu/17Aloo Gobhi Adraki.jpg',
        portionSize: '1.5kg',
        pricePerPortion: '₹499',
        basePrice: 499,
        serves: 20,
        quantity: '1.5kg',
        unit: 'kg'
    },
    {
        id: 715,
        title: 'Soya Chaap Masala',
        category: 'main',
        description: 'Semi-gravy soya chaap curry.',
        rating: 4.6,
        image: '/Images/MianVegMenu/18Soya Chaap Masala.jpg',
        portionSize: '2kg',
        pricePerPortion: '₹499',
        basePrice: 499,
        serves: 20,
        quantity: '2kg',
        unit: 'kg'
    },
    {
        id: 716,
        title: 'Dal Makhani',
        category: 'main',
        description: 'Slow-cooked black lentils.',
        rating: 4.9,
        image: '/Images/MianVegMenu/19Dal Makhani.jpg',
        portionSize: '2kg',
        pricePerPortion: '₹499',
        basePrice: 499,
        serves: 20,
        quantity: '2kg',
        unit: 'kg'
    },
    {
        id: 717,
        title: 'Dal Jodhpuri',
        category: 'main',
        description: 'Royal style dal from Rajasthan.',
        rating: 4.6,
        image: '/Images/MianVegMenu/DalJodhpuri.jpeg',
        portionSize: '2kg',
        pricePerPortion: '₹499',
        basePrice: 499,
        serves: 20,
        quantity: '2kg',
        unit: 'kg'
    },
    {
        id: 718,
        title: 'Amritsari Chole',
        category: 'main',
        description: 'Punjabi spiced chickpeas.',
        rating: 4.7,
        image: '/Images/MianVegMenu/21Amritsari Chole.jpg',
        portionSize: '2kg',
        pricePerPortion: '₹499',
        basePrice: 499,
        serves: 20,
        quantity: '2kg',
        unit: 'kg'
    },
    {
        id: 719,
        title: 'Hakka Noodles',
        category: 'main',
        description: 'Wok-tossed veg noodles.',
        rating: 4.5,
        image: '/Images/MianVegMenu/22Hakka Noodles.jpg',
        portionSize: '1.5kg',
        pricePerPortion: '₹499',
        basePrice: 499,
        serves: 20,
        quantity: '1.5kg',
        unit: 'kg'
    },
    {
        id: 720,
        title: 'Veg Manchurian',
        category: 'main',
        description: 'Veg balls in Manchurian sauce.',
        rating: 4.5,
        image: '/Images/MianVegMenu/23VegManchurian.jpg',
        portionSize: '1.5kg',
        pricePerPortion: '₹499',
        basePrice: 499,
        serves: 20,
        quantity: '1.5kg',
        unit: 'kg'
    },
    {
        id: 721,
        title: 'Veggies in Hot Garlic',
        category: 'main',
        description: 'Stir-fried veggies in hot garlic sauce.',
        rating: 4.5,
        image: '/Images/MianVegMenu/25Veggies in hot garlic.jpg',
        portionSize: '1.5kg',
        pricePerPortion: '₹499',
        basePrice: 499,
        serves: 20,
        quantity: '1.5kg',
        unit: 'kg'
    },
    {
        id: 722,
        title: 'Veg Thai Curry',
        category: 'main',
        description: 'Aromatic Thai style curry.',
        rating: 4.6,
        image: '/Images/MianVegMenu/26Veg Thai curry.jpg',
        portionSize: '2kg',
        pricePerPortion: '₹499',
        basePrice: 499,
        serves: 20,
        quantity: '2kg',
        unit: 'kg'
    },
    {
        id: 723,
        title: 'Pasta (Red/White/Pink)',
        category: 'main',
        description: 'Choice of sauces, cheesy and hearty.',
        rating: 4.4,
        image: '/Images/MianVegMenu/27PastaRedWhitePink.jpg',
        portionSize: '2kg',
        pricePerPortion: '₹499',
        basePrice: 499,
        serves: 20,
        quantity: '2kg',
        unit: 'kg'
    },
    {
        id: 724,
        title: 'Pao Bhaaji',
        category: 'main',
        description: 'Bhaaji with pav buns.',
        rating: 4.7,
        image: '/Images/MianVegMenu/28Pao Bhaaji.jpg',
        portionSize: '2kg + 30pc pav',
        pricePerPortion: '₹499',
        basePrice: 499,
        serves: 20,
        quantity: '2kg+30pc',
        unit: 'mixed'
    },

    // ===== RICE =====
    {
        id: 801,
        title: 'Steamed Rice',
        category: 'main',
        description: 'Plain steamed rice.',
        rating: 4.5,
        image: '/Images/MianVegMenu/29Steamed Rice.jpg',
        portionSize: '2kg',
        pricePerPortion: '₹499',
        basePrice: 499,
        serves: 20,
        quantity: '2kg',
        unit: 'kg'
    },
    {
        id: 802,
        title: 'Jeera Rice',
        category: 'main',
        description: 'Cumin tempered rice.',
        rating: 4.6,
        image: '/Images/MianVegMenu/30Jeera Rice.jpg',
        portionSize: '2kg',
        pricePerPortion: '₹499',
        basePrice: 499,
        serves: 20,
        quantity: '2kg',
        unit: 'kg'
    },
    {
        id: 803,
        title: 'Veg Fried Rice',
        category: 'main',
        description: 'Indo-Chinese fried rice.',
        rating: 4.5,
        image: '/Images/MianVegMenu/31Veg Fried Rice.jpg',
        portionSize: '2kg',
        pricePerPortion: '₹499',
        basePrice: 499,
        serves: 20,
        quantity: '2kg',
        unit: 'kg'
    },
    {
        id: 804,
        title: 'Shahi Pulao',
        category: 'main',
        description: 'Rich, fragrant pulao.',
        rating: 4.6,
        image: '/Images/MianVegMenu/32Shahi pulao.jpg',
        portionSize: '2kg',
        pricePerPortion: '₹499',
        basePrice: 499,
        serves: 20,
        quantity: '2kg',
        unit: 'kg'
    },
    {
        id: 805,
        title: 'Veg Pulao',
        category: 'main',
        description: 'Aromatic veg pulao.',
        rating: 4.5,
        image: '/Images/MianVegMenu/34Veg pulao.jpg',
        portionSize: '2kg',
        pricePerPortion: '₹499',
        basePrice: 499,
        serves: 20,
        quantity: '2kg',
        unit: 'kg'
    },
    {
        id: 806,
        title: 'Veg Biryani',
        category: 'main',
        description: 'Layered fragrant biryani.',
        rating: 4.6,
        image: '/Images/MianVegMenu/35Veg biryani.jpg',
        portionSize: '2kg',
        pricePerPortion: '₹499',
        basePrice: 499,
        serves: 20,
        quantity: '2kg',
        unit: 'kg'
    },

    // ===== BREADS =====
    {
        id: 901,
        title: 'Tandoori Roti',
        category: 'breads',
        description: 'Tandoor baked rotis.',
        rating: 4.6,
        image: '/Images/Breads/1Tandoori Roti.jpg',
        portionSize: '20pc',
        pricePerPortion: '₹499',
        basePrice: 499,
        serves: 20,
        quantity: '20pc',
        unit: 'pcs'
    },
    {
        id: 902,
        title: 'Naan / Butter Naan',
        category: 'breads',
        description: 'Soft naans with or without butter.',
        rating: 4.7,
        image: '/Images/Breads/2Naan-Butter Naan.jpg',
        portionSize: '20pc',
        pricePerPortion: '₹499',
        basePrice: 499,
        serves: 20,
        quantity: '20pc',
        unit: 'pcs'
    },
    {
        id: 903,
        title: 'Lachcha Paratha',
        category: 'breads',
        description: 'Layered parathas.',
        rating: 4.6,
        image: '/Images/Breads/3Lachcha Paratha.jpg',
        portionSize: '20pc',
        pricePerPortion: '₹499',
        basePrice: 499,
        serves: 20,
        quantity: '20pc',
        unit: 'pcs'
    },
    {
        id: 904,
        title: 'Garlic Naan',
        category: 'breads',
        description: 'Garlic-infused naan.',
        rating: 4.7,
        image: '/Images/Breads/4Garlic Naan.jpg',
        portionSize: '20pc',
        pricePerPortion: '₹499',
        basePrice: 499,
        serves: 20,
        quantity: '20pc',
        unit: 'pcs'
    },
    {
        id: 905,
        title: 'Misi Roti',
        category: 'breads',
        description: 'Spiced gram-flour roti.',
        rating: 4.4,
        image: '/Images/Breads/5Misi Roti.jpg',
        portionSize: '20pc',
        pricePerPortion: '₹499',
        basePrice: 499,
        serves: 20,
        quantity: '20pc',
        unit: 'pcs'
    },

    // ===== DESSERT =====
    {
        id: 1001,
        title: 'Gulab Jamun',
        category: 'dessert',
        description: 'Khoya dumplings in syrup.',
        rating: 4.8,
        image: '/Images/Desserts/1Gulab Jamun.jpg',
        serves: 20,
        quantity: '40pc',
        unit: 'pcs'
    },
    {
        id: 1002,
        title: 'Brownies',
        category: 'dessert',
        description: 'Chocolate fudge brownies.',
        rating: 4.6,
        image: '/Images/Desserts/2Brownies.jpg',
        portionSize: '30pc',
        pricePerPortion: '₹499',
        basePrice: 499,
        serves: 20,
        quantity: '30pc',
        unit: 'pcs'
    },
    {
        id: 1003,
        title: 'Mango Phirni',
        category: 'dessert',
        description: 'Creamy rice phirni with mango.',
        rating: 4.6,
        image: '/Images/Desserts/3Mango Phirni.jpg',
        portionSize: '2kg',
        pricePerPortion: '₹499',
        basePrice: 499,
        serves: 20,
        quantity: '2kg',
        unit: 'kg'
    },
    {
        id: 1004,
        title: 'Rasgulla',
        category: 'dessert',
        description: 'Spongy chhena balls in syrup.',
        rating: 4.7,
        image: '/Images/Desserts/4Rasgulla.jpg',
        portionSize: '40pc',
        pricePerPortion: '₹499',
        basePrice: 499,
        serves: 20,
        quantity: '40pc',
        unit: 'pcs'
    },
    {
        id: 1005,
        title: 'Kheer',
        category: 'dessert',
        description: 'Traditional rice pudding.',
        rating: 4.7,
        image: '/Images/Desserts/5Kheer.jpg',
        portionSize: '2kg',
        pricePerPortion: '₹499',
        basePrice: 499,
        serves: 20,
        quantity: '2kg',
        unit: 'kg'
    },
    {
        id: 1006,
        title: 'Moongdal Halwa',
        category: 'dessert',
        description: 'Ghee-rich moong dal halwa.',
        rating: 4.8,
        image: '/Images/Desserts/6Moongdal Halwa.jpg',
        portionSize: '2kg',
        pricePerPortion: '₹499',
        basePrice: 499,
        serves: 20,
        quantity: '2kg',
        unit: 'kg'
    }
];
